import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseCrudComponent } from 'app/base';
import { PrestacaoConta } from 'app/entity/prestacao-conta.model';
import * as FileSaver from 'file-saver';
import { ResultadoPrestacaoConta } from 'app/entity/resultado-prestacao-conta.model';
import { ResultadoPrestacaoContaPontuacao } from 'app/entity/resultado-prestacao-conta-pontuacao.model';
import { FuncaoExercidaPrestacaoConta } from 'app/entity/funcao-exercida_prestacao_conta.model';
import { GrupoAtividade } from 'app/entity/enumeraveis';

@Component({ template: '' })
export class BasePrestacaoContaComponent extends BaseCrudComponent {
    controllerName = 'prestacaoConta';

    listaAquisicaoConhecimento: any[] = [];
    listaSomatorioAquisicaoConhecimento: any[] = [];

    listaDocencia: any[] = [];
    listaSomatorioDocencia: any[] = [];

    listaAtuacaoComoParticipante: any = [];
    listaSomatorioAtuacaoComoParticipante: any = [];

    listaProducaoIntelectual: any = [];
    listaSomatorioProducaoIntelectual: any = [];

    listaSomatorioTotal: any[] = [];

    resultadoPrestaoConta: ResultadoPrestacaoConta = new ResultadoPrestacaoConta;
    resultadoPrestaoContaPontuacao: ResultadoPrestacaoContaPontuacao = new ResultadoPrestacaoContaPontuacao;
    listResultadoPrestacaoConta: ResultadoPrestacaoConta[] = [];
    listaResultadoPrestaoContaPontuacao: ResultadoPrestacaoContaPontuacao[] = [];

    funcaoExercidaPrestacaoConta: FuncaoExercidaPrestacaoConta = new FuncaoExercidaPrestacaoConta;
    listFuncaoExercidaPrestacaoConta: FuncaoExercidaPrestacaoConta[] = [];

    PrestacaoContaDto: PrestacaoConta = new PrestacaoConta();

    @Input() listaFuncao: any[] = [];
    @Input() listaEnderecos: any[] = [];
    @Input() listaTelefones: any[] = [];
    @Input() listaEmails: any[] = [];

    funcaoExercida: SelectItem[] = [];
    idEditar: number = 0;
    modalTermoAceiteLGPD: any = false;

    pesquisaPorDados(cpf?: any) {

        this.service.ServicoPrestacaoConta(this.controllerName + "/listarPrestacaoConta", this.idEditar, this.limpaCaracterEspecial(cpf), this.listaFuncao).subscribe(retorno => {
            this.listaDocencia = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Docencia);
            this.listaSomatorioDocencia = retorno.somatorioDocencia;

            this.listaAquisicaoConhecimento = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Aquisição_de_conhecimento);
            this.listaSomatorioAquisicaoConhecimento = retorno.somatorioAquisicaoConhecimento;

            this.listaAtuacaoComoParticipante = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Atuação_como_participante);
            this.listaSomatorioAtuacaoComoParticipante = retorno.somatorioAtuacaoComoParticipante;

            this.listaProducaoIntelectual = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Producao_Intelectual);
            this.listaSomatorioProducaoIntelectual = retorno.somatorioProducaoIntelectual;

            this.listaSomatorioTotal = retorno.somatorioTotal;
            this.idEditar = retorno.id_prestacao_conta;
        });

    }

    finalizar() {
        if (this.acao != "visualizar") {
            if (this.acao == "enviar-cadastro") {
                if (!this.cadastro.get('etapa3.aceite').value) {
                    this.showMsgWarn(`É necessário aceitar os termos de aceite para enviar a sua Prestação de Contas.`);
                } else {
                    //se nao processo como era antes
                    this.confirmacao.confirm({
                        header: 'Mensagem de Confirmação',
                        message: `Atenção! Ao confirmar esta operação, a Prestação de Contas será enviada para Análise.
                            Deseja realmente confirmar esta operação?`,
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.EnviarPrestacaoConta(this.controllerName, { id: this.idEditar, id_situacao: 17, aceite: true }, { parcial: "id_situacao" })
                                .subscribe(() => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    if(this.acao == 'cadastrar'){
                                        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                                    }else{
                                        this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                                    }
                                    return this.TratarMsgEnviarEditar(true);
                                },
                                    err => {
                                        this.observableUtilPanelDoc.setBlockedPanel(false)
                                        super.showMsgError(`Erro ao Enviar o Cadastro. ${err._body}`)
                                    });
                        }
                    });
                this.observableUtilPanelDoc.setBlockedPanel(false);
                }
                return;
            }
            this.listResultadoPrestacaoConta = [];
            this.listaSomatorioTotal.map(x => {
                this.listaResultadoPrestaoContaPontuacao = [];
                this.resultadoPrestaoConta = new ResultadoPrestacaoConta;
                x.resultado_prestacao_conta_pontuacao.map(y => {
                    this.resultadoPrestaoContaPontuacao = new ResultadoPrestacaoContaPontuacao;
                    this.resultadoPrestaoContaPontuacao.id = y.id;
                    this.resultadoPrestaoContaPontuacao.id_pontuacao = y.id_pontuacao;
                    this.resultadoPrestaoContaPontuacao.id_resultado_prestacao_conta = y.id_resultado_prestacao_conta;
                    this.resultadoPrestaoContaPontuacao.resultado = y.resultado;
                    this.resultadoPrestaoContaPontuacao.valor_pontuacao = y.valor_pontuacao;
                    this.listaResultadoPrestaoContaPontuacao.push(this.resultadoPrestaoContaPontuacao);
                })
                this.resultadoPrestaoConta.id = x.id;
                this.resultadoPrestaoConta.resultado_final = x.resultado_final;
                this.resultadoPrestaoConta.id_funcao_exercida = x.id_funcao_exercida;
                this.resultadoPrestaoConta.id_prestacao_conta = x.id_prestacao_conta;
                this.resultadoPrestaoConta.resultado_prestacao_conta_pontuacao = this.listaResultadoPrestaoContaPontuacao;
                this.listResultadoPrestacaoConta.push(this.resultadoPrestaoConta);
            });

            this.listFuncaoExercidaPrestacaoConta = [];
            this.listaFuncao.map(x => {
                this.funcaoExercidaPrestacaoConta = new FuncaoExercidaPrestacaoConta;
                this.funcaoExercidaPrestacaoConta.id_funcao_exercida = x.id_funcao_exercida;
                this.funcaoExercidaPrestacaoConta.id_hipoteses = x.id_hipoteses;
                this.listFuncaoExercidaPrestacaoConta.push(this.funcaoExercidaPrestacaoConta);
            });

            //PASSO A PASSO
            //1- ADICIONAR EM CADA OBJETO DA LISTA A PROPRIEDADE CLASSE COM NOME DEFAULT JÁ PREENCHIDO
            //2- PERCORRER A LISTA COM FOR E ADICIONAR UM A UM CADA ELEMENTO NA VARIÁVEL PARAMETROS DO FORMULÁRIO
            //3- VALIDAR SE TODOS OS ELEMENTOS DO FORMULÁRIO DA TELA SÃO PREENCHIDOS E ENVIADOS AO CONTROLLER
            //4- VALIDAR SE TODOS OS VALORES ENVIADOS AO CONTROLLER SÃO DEVIDAMENTE ATUALIZADOS SEM ERRO
            //5- VALIDAR SE O MÉTODO EXCLUIR REALMENTE FUNCIONA
            //6- VALIDAR SE O MÉTODO SALVAR REALMENTE FUNCIONA


            var ParametrosDoFormulario = [];

            //ADICIONANDO OS OBJETOS DO TIPO EnderecoProfissionalPrestacaoContaDto
            if (this.listaEnderecos.length > 0) {
                this.listaEnderecos.forEach(endereco => {
                    endereco.classe = "EnderecoProfissionalPrestacaoContaDto",
                        endereco.num_cep = this.limpaCaracterEspecial(endereco.num_cep);
                    ParametrosDoFormulario.push(endereco);
                });
            }

            //ADICIONANDO OS OBJETOS DO TIPO FuncaoExercidaPrestacaoContaDto
            if (this.listFuncaoExercidaPrestacaoConta.length > 0) {
                this.listFuncaoExercidaPrestacaoConta.forEach(funcao => {
                    funcao.classe = "FuncaoExercidaPrestacaoContaDto";
                    ParametrosDoFormulario.push(funcao);
                });
            }

            //ADICIONANDO OS OBJETOS DO TIPO EmailProfissionalPrestacaoContaDto
            if (this.listaEmails.length > 0) {
                this.listaEmails.forEach(email => {
                    email.classe = "EmailProfissionalPrestacaoContaDto";
                    ParametrosDoFormulario.push(email);
                });
            }

            //ADICIONANDO OS OBJETOS DO TIPO TelefoneProfissionalPrestacaoContaDto
            if (this.listaTelefones.length > 0) {
                this.listaTelefones.forEach(telefone => {
                    telefone.classe = "TelefoneProfissionalPrestacaoContaDto";
                    ParametrosDoFormulario.push(telefone);
                });
            }

            //ADICIONANDO OS OBJETOS DO TIPO ResultadoPrestacaoContaDto

            if (this.listResultadoPrestacaoConta.length > 0) {
                this.listResultadoPrestacaoConta.forEach(resultado => {
                    resultado.classe = "ResultadoPrestacaoContaDto";
                    ParametrosDoFormulario.push(resultado);
                });
            }

            //ADICIONAR A PROPRIEDADE CLASSE EM TODOS
            var idPrestacaoContaDto = { "idPrestacaoContaDto": this.idEditar, "classe": "id" };
            ParametrosDoFormulario.push(idPrestacaoContaDto);

            this.confirmacao.confirm({
                header: 'Mensagem de Confirmação',
                message: `Atenção! Ao confirmar esta operação, a Prestação de Contas será atualizada na base de dados.
            Deseja realmente confirmar esta operação?`,
                accept: () => {
                    if (this.acao == 'editar' || this.acao == 'cadastrar') {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.AtualizarPrestacaoConta(this.controllerName, ParametrosDoFormulario, this.PrestacaoContaDto).subscribe(() => {
                            const rota = this.acao == 'cadastrar' ? '../' : '../../';
                            this.router.navigate([rota], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            return this.TratarMsgEnviarEditar();
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsgError(`Erro ao gravar. ${err._body}`);
                        });
                    }
                }
            });
        }
        else {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.GerarCertidao('relatorio/gerarRelatorio', { id: this.idEditar, id_lotacao: localStorage.getItem("lotacao"), logo: localStorage.getItem("path") }).subscribe(x => {
                FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), "Relatório Prestação de Conta");
                this.observableUtilPanelDoc.setBlockedPanel(false)
            }, err => {
                this.observableUtilPanelDoc.setBlockedPanel(false)
                this.showMsgError(`Erro ao gerar a impressão. ${err._body}`)
            });
        }
    }

    TratarMsgEnviarEditar(enviar: boolean = false): void {
        return !this.profissionalEnviouAposPrazoInicial
            ? sessionStorage.setItem('msg', 'Registro salvo com sucesso.')
            : sessionStorage.setItem('msgWarn', `A sua prestação de contas foi ${(enviar ? 'enviada' : 'editada')} após
                                    o dia 31 de janeiro de ${this.obj.exercicio}, portanto está intempestiva e
                                    será analisada pelas Comissões de Educação Profissional Continuada do CFC/CRCs
                                    quanto à intempestividade da entrega.`);
    }

    get profissionalEnviouAposPrazoInicial(): boolean {
        return this.ehProfissional &&
            this.DataSemHora(new Date()) > this.DataSemHora(new Date(this.obj.anoExercicio + 1, 0, 31))
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base-prestacao-conta.component.ts